var BannerType = /* @__PURE__ */ ((BannerType2) => {
  BannerType2["Micro"] = "micro";
  BannerType2["Theme"] = "theme";
  BannerType2["Brand"] = "brand";
  BannerType2["Home"] = "home";
  return BannerType2;
})(BannerType || {});
var BannerActionType = /* @__PURE__ */ ((BannerActionType2) => {
  BannerActionType2["Deposit"] = "deposit";
  BannerActionType2["Register"] = "register";
  BannerActionType2["InternalUrl"] = "internal_url";
  BannerActionType2["ExternalUrl"] = "external_url";
  BannerActionType2["Game"] = "game";
  return BannerActionType2;
})(BannerActionType || {});
export {
  BannerActionType,
  BannerType
};
